export const filtersModel = {
  all: {
    type: {},
    min_age: {},
    ability_fono: {},
    ability_paid: {},
    ability_free: {},
    others_abilities: [],
    difficulties: {},
    language: [],
    
  },
  active: {
    total: 0,
    name: {
      total: 0,
      value: "",
    },
    order_by: {
      total: 0,
      value: "",
    },
    type: {
      game:true,
      audio:true,
      total: 0,
    },
    min_age: { total: 0 },
    ability_fono: { total: 0 },
    ability_paid: { total: 0 },
    ability_free: { total: 0 },
    difficulties: { total: 0 },
    language: { total: 0 },
    
  },
  totalActive:0,
};
